export enum StockLevelStatus {
  inStock = 'inStock',
  outOfStock = 'outOfStock',
  lowStock = 'lowStock'
}

export interface ProductStockData {
  code: string
  stock: {
    stockLevel?: number
    stockLevelStatus?: StockLevelStatus | string
  }
}
